var _style, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPieChartV2 = function SvgPieChartV2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgPieChart2",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.svgPieChart2{fill:#B5B5B5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1752",
    transform: "translate(2.5 2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1496",
    className: "svgPieChart2 svgBase svgHover svgSelect",
    d: "M7.1,6.3v-7.9c0-0.5-0.4-0.8-0.8-0.8c-4.8,0-8.7,3.8-8.7,8.6c0,0,0,0.1,0,0.1 c0,0.5,0.4,0.8,0.8,0.8h7.9C6.8,7.1,7.1,6.8,7.1,6.3z M5.5-0.7v6.1h-6.1C-0.3,2.2,2.2-0.3,5.5-0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1497",
    className: "svgPieChart2 svgBase svgHover svgSelect",
    d: "M8.7-0.6c-0.5,0-0.8,0.4-0.8,0.8s0.4,0.8,0.8,0.8l0,0c1.9,0,3.7,0.7,5.1,2c1.3,1.4,2,3.2,2,5.1 c0,4.1-3.4,7.5-7.5,7.5c-3.8,0.1-7-2.8-7.1-6.6c0-0.2,0-0.3,0-0.5c0-0.5-0.4-0.8-0.8-0.8s-0.8,0.4-0.8,0.8c0,2.4,0.9,4.6,2.5,6.3 c1.7,1.6,4,2.5,6.3,2.5c5.1,0,9.2-4.1,9.2-9.2c0.2-4.7-3.4-8.6-8.1-8.8C9.1-0.6,8.9-0.6,8.7-0.6z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPieChartV2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pie_chart_v2.24781d6c.svg";
export { ForwardRef as ReactComponent };